import React from 'react';
import { formatGameDate } from '../utils/dateFormatter';
import './GraphicRecapPhotoFrame.css';

function GraphicRecapPhotoFrame({
  graphicData,
  teamColors,
  backgroundStyle = 'linear-gradient',
  showWatermark = true,
  dateFormat = 'full',
}) {
  const {
    homeTeam,
    homeScore,
    awayTeam,
    awayScore,
    gameDate,
    topPerformer,
    topPerformerStats,
    backgroundPhoto,
  } = graphicData;
  const bgImageScale = (graphicData.bgImageScale ?? 100) / 100;
  const bgImageX = graphicData.bgImageX ?? 50;
  const bgImageY = graphicData.bgImageY ?? 50;

  const homeWon = parseInt(homeScore) > parseInt(awayScore);
  const isTie = parseInt(homeScore) === parseInt(awayScore);

  const getBackgroundStyle = () => {
    switch (backgroundStyle) {
      case 'linear-gradient':
        return `linear-gradient(135deg, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`;
      case 'radial-gradient':
        return `radial-gradient(circle at center, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`;
      case 'diagonal-gradient':
        return `linear-gradient(45deg, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`;
      case 'split-two-tone':
        return `linear-gradient(90deg, ${teamColors.primary} 0%, ${teamColors.primary} 50%, ${teamColors.secondary} 50%, ${teamColors.secondary} 100%)`;
      case 'solid-primary':
        return teamColors.primary;
      case 'solid-secondary':
        return teamColors.secondary;
      default:
        return `linear-gradient(135deg, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`;
    }
  };

  return (
    <div
      className="graphic-recap-photo-frame"
      id="graphic-recap"
      style={{ background: getBackgroundStyle() }}
    >
      {/* Background Photo */}
      <div className="recap-photo-frame-background">
        {backgroundPhoto ? (
          <img
            src={backgroundPhoto}
            alt="Background"
            crossOrigin="anonymous"
            style={{
              position: 'absolute',
              top: `${bgImageY}%`,
              left: `${bgImageX}%`,
              transform: `translate(-50%, -50%) scale(${bgImageScale})`,
              transformOrigin: 'center center',
              width: 'auto',
              height: 'auto',
              minWidth: '100%',
              minHeight: '100%',
              maxWidth: 'none',
            }}
          />
        ) : (
          <div
            className="recap-photo-frame-placeholder"
            style={{ background: getBackgroundStyle() }}
          >
            <div className="recap-placeholder-icon">📸</div>
            <div className="recap-placeholder-text">
              Upload a team or field photo
            </div>
          </div>
        )}
        <div className="recap-photo-frame-overlay"></div>
      </div>

      {/* Content Overlay */}
      <div className="recap-photo-frame-content">
        {/* Top Badge */}
        <div
          className="recap-photo-frame-badge"
          style={{
            background: `linear-gradient(90deg, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`,
          }}
        >
          {isTie ? 'TIE GAME' : homeWon ? 'VICTORY!' : 'FINAL SCORE'}
        </div>

        {/* Main Info - Bottom with Two Columns */}
        <div className="recap-photo-frame-info">
          <div className="recap-photo-frame-columns">
            {/* Left Column - Score & Teams */}
            <div className="recap-photo-frame-left">
              <div className="recap-photo-frame-score">
                {homeScore || '0'} - {awayScore || '0'}
              </div>

              <div className="recap-photo-frame-teams">
                <div className="recap-photo-frame-team">
                  {homeTeam || 'YOUR TEAM'}
                </div>
                <div className="recap-photo-frame-vs">VS</div>
                <div className="recap-photo-frame-team">
                  {awayTeam || 'OPPONENT'}
                </div>
              </div>
              {gameDate && (
                <div className="recap-photo-frame-date">
                  {formatGameDate(gameDate, dateFormat)}
                </div>
              )}
            </div>

            {/* Right Column - Player of the Game */}
            {topPerformer && (
              <div className="recap-photo-frame-right">
                <div className="recap-performer-label">
                  ⭐ PLAYER OF THE GAME
                </div>
                <div className="recap-performer-name">{topPerformer}</div>
                {topPerformerStats && (
                  <div className="recap-performer-stats">
                    {topPerformerStats}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {showWatermark && (
        <div className="playmaker-watermark">
          <img src="/PMlogoleft.png" alt="Playmaker Media Kit" />
        </div>
      )}
    </div>
  );
}

export default GraphicRecapPhotoFrame;
